@import "../../../../src/VX/Asset/Less/Base/01-settings/globals.less";

.countdown-wrapper {
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: @color-special;
  padding: 5px 10px;
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  z-index: 102;

  .min-sm({
    max-width: 550px;
    top: auto;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    grid-template-columns: auto 1px auto;
    border-radius: 27px;
    height: 55px;
    padding: 10px 10px;
	});
}

.countdown-line {
  width: 1px;
  height: 100%;
  background-color: white;
}

.countdown {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  grid-column-gap: 10px;
}

.countdown__icon {
  height: 30px;
  width: auto;
  transform: translateY(-3px);
}

.countdown__text {
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;
  max-width: 130px;

  .min-sm({
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    max-width: unset;
	});
}

.countdown__text-time {
  font-weight: 700;
  font-size: 20px;
  line-height: 18px;
  padding-left: 5px;
  display: inline-block;
  transform: translateY(3px);

  .min-sm({
    transform: translateY(0);
    font-size: 30px;
    line-height: 35px;
    font-weight: 600;
	});
}

.countdown__button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  .min-sm({
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
	});
}

.badge {
  background-color: @color-special;
  border-radius: 8px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  font-weight: 400;
  color: white;
  width: max-content;
  padding: 0 5px;
  box-shadow: rgba(0, 0, 0, 1) 0px 1px 5px;

  img {
    margin-right: 2px;
    height: 11px;
    width: auto;
    transform: translateY(-1px);
  }
}

.badge--mobile-menu {
  top: -5px;

  &::before {
    content: " ";
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid @color-special;
    bottom: -7px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.badge--mobile-sub-menu {
  position: relative;
  top: unset;
  transform: unset;
  left: unset;
  margin-left: 10px;
  text-transform: initial;
  translate: 0 -2px;
}
